export default __webpack_public_path__ + "static/media/Confluence-PH.266fab95.gif";